// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-q_fV","galleryItem_borderTopRadius":"c-q_fW","galleryItem__image":"c-q_fX","galleryItem__image_withBlur":"c-q_fY"};